import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step1', 'Step 1: Can eligible employees enter the plan within 3 years of being hired and does this apply to all eligible employees?', {
        nextComponent: () => 'step2',
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step1.js